import React from 'react';
import getColor from '../utils/interpolateColor';
import { getProgressBarFillPercent } from '../utils/progressBarDisplayWidth';
import ParameterIcon from './ParameterIcon.jsx';
import { useTranslation } from '../hooks/useTranslation';

const ProgressBar = ({ value = 0, label = '', darkMode = false, highlight = false, iconSize = 48 }) => {
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const barColor = getColor(clamped);
  const percentage = getProgressBarFillPercent(clamped);
  const { t } = useTranslation();

  return (
    <div className={`relative w-full rounded-full border border-gray-200 ${highlight ? 'bg-yellow-100' : 'bg-gray-100'} overflow-hidden`}>
      {!highlight && (
        <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${percentage}%`, backgroundColor: barColor }} />
      )}
      {/* Consupedia padding: no left padding when icon is present */}
      <div className="relative z-10 flex items-center justify-between" style={{ padding: '0 6px 0 0' }}>
        <div className="flex items-center space-x-3">
          <ParameterIcon title={label} width={iconSize} height={iconSize} />
          <span className={`text-sm font-normal ${darkMode ? 'text-gray-800' : 'text-gray-900'}`}>{t(label)}</span>
        </div>
        <span className={`text-sm font-black ${darkMode ? 'text-gray-900' : 'text-gray-900'}`}>{Math.round(clamped)}/100</span>
      </div>
    </div>
  );
};

const ProgressBarComponents = ({ items = [], darkMode = false, sectionNote = '', groupKey = '', highlightIndex = null, iconSize = 48 }) => {
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <div className="space-y-3">
      {sectionNote ? (
        <div className={`text-xs font-semibold ${darkMode ? 'text-gray-200' : 'text-gray-700'} mb-1`}>{sectionNote}</div>
      ) : null}
      {items.map((it, idx) => (
        <ProgressBar key={it.key} value={it.value} label={it.label} darkMode={darkMode} highlight={highlightIndex === idx} iconSize={iconSize} />
      ))}
    </div>
  );
};

export default ProgressBarComponents;


